import type { GoogleLatLngLiteral } from "./types";

export const defaultLocation: GoogleLatLngLiteral = { lat: 13.745961960620082, lng: 100.53821213284425 };
